import { createReducer } from "typesafe-actions";

import SortOrder from "@mapmycustomers/shared/enum/SortOrder";
import ViewState from "@mapmycustomers/shared/types/viewModel/ViewState";

import routeFieldModel, { RouteFieldName } from "@app/util/fieldModel/RouteFieldModel";
import { createEmptyFilterModel } from "@app/util/filters/utils";

import { Actions, applyListViewSettings, fetchRoutesList, initializeListView } from "./actions";

export const LIST_VIEW_KEY = "route/listView";

export interface ListViewState {
  initialized: boolean;
  loading: boolean;
  totalFilteredRecords: number;
  totalRecords: number;
  viewState: ViewState;
}

const startAtField = routeFieldModel.getByName(RouteFieldName.START_AT)!;

export const defaultViewState: ViewState = {
  ...routeFieldModel.getDefaultListViewState(),
  filter: createEmptyFilterModel(),
  range: { endRow: 25, startRow: 0 },
  sort: [{ field: startAtField, order: SortOrder.DESC }],
};

const initialState: ListViewState = {
  initialized: false,
  loading: false,
  totalFilteredRecords: 0,
  totalRecords: 0,
  viewState: defaultViewState,
};

const listView = createReducer<ListViewState, Actions>(initialState)
  .handleAction(initializeListView.success, (state, { payload }) => ({
    ...state,
    initialized: true,
    viewState: payload,
  }))
  .handleAction(applyListViewSettings, (state, { payload }) => ({
    ...state,
    viewState: { ...state.viewState, ...payload },
  }))
  .handleAction(fetchRoutesList.request, (state) => ({ ...state, loading: true }))
  .handleAction(fetchRoutesList.success, (state, { payload }) => ({
    ...state,
    loading: false,
    totalFilteredRecords: payload.totalFilteredRecords,
    totalRecords: payload.totalRecords,
  }))
  .handleAction(fetchRoutesList.failure, (state) => ({ ...state, loading: false }));

export type ListViewActions = Actions;
export default listView;
